// models
import { SyncAnalysis, SyncAnalysisFinding, SyncAnalysisFindingDecision } from '../../models/Entities/Protocols/SyncAnalysis';
import { PaginationState } from '../../models/PaginationState';
import { ErrorType } from '../../models/HttpError';

// Análisis de una corrida de sincronización
export const SYNCANALYSIS_GET_REQUEST = 'SYNCANALYSIS_GET_REQUEST';
export const SYNCANALYSIS_GET_SUCCESS = 'SYNCANALYSIS_GET_SUCCESS';
export const SYNCANALYSIS_GET_FAILURE = 'SYNCANALYSIS_GET_FAILURE';

export interface SyncAnalysisGetRequestAction {
	type: typeof SYNCANALYSIS_GET_REQUEST;
	syncProcessId: string;
}

export interface SyncAnalysisGetSuccessAction {
	type: typeof SYNCANALYSIS_GET_SUCCESS;
	syncProcessId: string;
	// null cuando la corrida todavía no fue analizada.
	analysis: SyncAnalysis | null;
}

export interface SyncAnalysisGetFailureAction {
	type: typeof SYNCANALYSIS_GET_FAILURE;
	syncProcessId: string;
	error: ErrorType;
}

// Hallazgos del análisis
export const SYNCANALYSIS_GETFINDINGS_REQUEST = 'SYNCANALYSIS_GETFINDINGS_REQUEST';
export const SYNCANALYSIS_GETFINDINGS_SUCCESS = 'SYNCANALYSIS_GETFINDINGS_SUCCESS';
export const SYNCANALYSIS_GETFINDINGS_FAILURE = 'SYNCANALYSIS_GETFINDINGS_FAILURE';

export interface SyncAnalysisGetFindingsRequestAction {
	type: typeof SYNCANALYSIS_GETFINDINGS_REQUEST;
	analysisId: string;
}

export interface SyncAnalysisGetFindingsSuccessAction {
	type: typeof SYNCANALYSIS_GETFINDINGS_SUCCESS;
	analysisId: string;
	findings: SyncAnalysisFinding[];
	paginationState: PaginationState;
}

export interface SyncAnalysisGetFindingsFailureAction {
	type: typeof SYNCANALYSIS_GETFINDINGS_FAILURE;
	analysisId: string;
	error: ErrorType;
}

// Ejecución a demanda del análisis sobre una corrida ya existente
export const SYNCANALYSIS_EXECUTE_REQUEST = 'SYNCANALYSIS_EXECUTE_REQUEST';
export const SYNCANALYSIS_EXECUTE_SUCCESS = 'SYNCANALYSIS_EXECUTE_SUCCESS';
export const SYNCANALYSIS_EXECUTE_FAILURE = 'SYNCANALYSIS_EXECUTE_FAILURE';

export interface SyncAnalysisExecuteRequestAction {
	type: typeof SYNCANALYSIS_EXECUTE_REQUEST;
	syncProcessId: string;
}

export interface SyncAnalysisExecuteSuccessAction {
	type: typeof SYNCANALYSIS_EXECUTE_SUCCESS;
	syncProcessId: string;
	analysisId: string;
}

export interface SyncAnalysisExecuteFailureAction {
	type: typeof SYNCANALYSIS_EXECUTE_FAILURE;
	syncProcessId: string;
	error: ErrorType;
}

/**
 * Relectura de fondo de un análisis en curso. Va aparte del GET normal porque no
 * tiene que mover las banderas de carga: el sondeo se repite solo y haría
 * parpadear spinners y botones deshabilitados cada pocos segundos.
 */
export const SYNCANALYSIS_REFRESH_SUCCESS = 'SYNCANALYSIS_REFRESH_SUCCESS';

export interface SyncAnalysisRefreshSuccessAction {
	type: typeof SYNCANALYSIS_REFRESH_SUCCESS;
	syncProcessId: string;
	analysis: SyncAnalysis | null;
}

// Decisión del analista sobre un hallazgo
export const SYNCANALYSIS_SETDECISION_REQUEST = 'SYNCANALYSIS_SETDECISION_REQUEST';
export const SYNCANALYSIS_SETDECISION_SUCCESS = 'SYNCANALYSIS_SETDECISION_SUCCESS';
export const SYNCANALYSIS_SETDECISION_FAILURE = 'SYNCANALYSIS_SETDECISION_FAILURE';

export interface SyncAnalysisSetDecisionRequestAction {
	type: typeof SYNCANALYSIS_SETDECISION_REQUEST;
	findingId: string;
}

export interface SyncAnalysisSetDecisionSuccessAction {
	type: typeof SYNCANALYSIS_SETDECISION_SUCCESS;
	decision: SyncAnalysisFindingDecision;
}

export interface SyncAnalysisSetDecisionFailureAction {
	type: typeof SYNCANALYSIS_SETDECISION_FAILURE;
	findingId: string;
	error: ErrorType;
}
